<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("ventasPorNegocio")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="getComprasNegocios(true)">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>


                        <div class="col-md-2">
                            <div class="form-group">
                                <label for="datefrom">{{$t("desde")}}</label>
                                <el-date-picker v-model="datefrom"
                                                type="date"
                                                id="datefrom"
                                                :placeholder="$t('fechaDesde')"
                                                format="dd-MM-yyyy">
                                </el-date-picker>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label for="dateto">{{$t("hasta")}}</label>
                                <el-date-picker v-model="dateto"
                                                type="date"
                                                id="dateto"
                                                :placeholder="$t('fechaHasta')"
                                                format="dd-MM-yyyy">
                                </el-date-picker>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button class="btn btn-primary" @click="getComprasNegocios"><i
                                        class="fa fa-refresh" v-if="loading"></i>
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <template v-if="data.length > 0">
                        <div class="row justify-content-between div-export">
                            <div class="col-md-6 col-xs-12">
                                <i class="fa fa-info-circle"></i>
                                <small>
                                    {{$t("infoConsumo")}}
                                </small>
                            </div>
                            <div class="col-md-2 col-xs-12 text-right">
                                <el-dropdown>
                                    <el-button type="primary" size="small">
                                        <i class="fa fa-file"></i>
                                        {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <a :href="urlExportPDF">
                                            <el-dropdown-item>
                                                <strong><i class="fa fa-file-pdf-o"></i> {{$t("exportarPdf")}}</strong>
                                            </el-dropdown-item>
                                        </a>
                                        <a :href="urlExportExcel">
                                            <el-dropdown-item>
                                                <strong><i class="fa fa-file-excel-o"></i> {{$t("exportarExcel")}}</strong>
                                            </el-dropdown-item>
                                        </a>
                                    </el-dropdown-menu>
                                </el-dropdown>

                            </div>
                        </div>

                        <div class="table-responsive">
                            <table class="table table-bordered table-striped">
                                <thead class="thead-dark">
                                <tr>
                                    <th>{{$t("fecha")}}</th>
                                    <th>{{$t("subproducto")}}</th>
                                    <th>{{$t("unidades")}}</th>
                                    <th>{{$t("partes")}}</th>
                                    <th>{{$t("precio")}}</th>
                                    <th>{{$t("casa")}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="obj in data">
                                    <td>{{obj.date | parseDate}}</td>
                                    <td>{{obj.nameSubproduct}}</td>
                                    <td class="text-right">{{obj.ud}}</td>
                                    <td class="text-right">{{obj.partes}}</td>
                                    <td class="text-right">{{obj.total | currency}}</td>
                                    <td>{{obj.nameCasa}}</td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr class="table-success">
                                    <td><strong>{{$t("total")}}</strong></td>
                                    <td></td>
                                    <td class="text-right"><strong>{{getTotalUnidades}}</strong></td>
                                    <td class="text-right"><strong>{{getTotalPartes}}</strong></td>
                                    <td class="text-right"><strong>{{getTotalPrecio | currency}}</strong></td>
                                    <td></td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </template>
                    <template v-else>
                        <p><i class="fa fa-info-circle"></i>
                            <small>
                                {{$t("infoConsumo")}}
                            </small>
                        </p>
                        <div class="alert alert-danger" role="alert">
                            {{$t("noHay")}} <strong>{{$t("gastos")}}</strong> {{$t("rangoDeFechas")}}
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import bus from '../../../../bus'

    export default {
        created() {
            this.$store.dispatch("setNameRoute", this.$i18n.t("ventasPorNegocio"));
            this.getBusiness();

            bus.$on('getVentas', function () {
                this.getVentas()
            });
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                dateto: new Date(),
                listBusinesses: [],
                listCasas: [],
                idBusiness: 0,
                idCasa: 0,
                data: [''],
            }
        },
        computed: {
            urlExportPDF() {
                // return "../api/public/index.php/casas/exportComprasNegocios/PDF?idBusiness=" + this.idBusiness + "&idCasa=" + this.idCasa + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt
       
                return this.$store.getters.apiUrl+"/casas/exportComprasNegocios/PDF?idBusiness=" + this.idBusiness + "&idCasa=" + this.idCasa + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt
            },
            urlExportExcel() {
                return this.$store.getters.apiUrl+"/casas/exportComprasNegocios/Excel?idBusiness=" + this.idBusiness + "&idCasa=" + this.idCasa + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt
            },
            getTotalUnidades() {
                let uds = 0;
                this.data.forEach(function (d) {
                    uds += d.ud;
                });
                return uds;
            },
            getTotalPartes() {
                let partes = 0;
                this.data.forEach(function (d) {
                    partes += d.partes;
                });
                return partes;
            },
            getTotalPrecio() {
                let total = 0;
                this.data.forEach(function (d) {
                    total += d.total;
                });
                return total;
            }
        },
        methods: {
            getBusiness() {
                var config = {
                    params:{
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {
                        vm.idBusiness = response.data.result[0].id;
                        vm.listBusinesses = response.data.result;

                        vm.getComprasNegocios();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getComprasNegocios(resetCasa) {

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: $t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {

                        this.loading = true;
                        if (resetCasa === true) {
                            this.idCasa = 0;
                        }

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                idCasa: this.idCasa,
                                datefrom: moment(this.datefrom).unix(),
                                dateto: moment(this.dateto).unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.axios.get(this.$store.getters.apiUrl + "casas/getComprasNegocios", config)
                            .then(function (response) {
                                if (response.data.response) {
                                    vm.data = response.data.result;

                                    let listCasas = new Array();

                                    for (let i = 0; i < response.data.result.length; i++) {
                                        if (!vm.arrayContainsCasa(listCasas, response.data.result[i].nameCasa)) {
                                            let casa = new Object();
                                            casa.idCasa = response.data.result[i].idCasa;
                                            casa.nameCasa = response.data.result[i].nameCasa;
                                            listCasas.push(casa);
                                        }
                                    }

                                    listCasas.sort();

                                    vm.listCasas = listCasas;
                                }
                                vm.loading = false;

                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },
            arrayContainsCasa(listCasas, nameCasa) {
                let found = false;
                for (let i = 0; i < listCasas.length; i++) {
                    if (listCasas[i]) {
                        if (listCasas[i].nameCasa === nameCasa) {
                            found = true;
                            break;
                        }
                    }
                }
                return found;
            }
        }
    }
</script>

<style scoped>


    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Productos/VentasNegocios.vue